import React, { useEffect } from 'react';
import SEO from './SEO';

const PrivacyPolicy: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="pt-32 pb-20 container mx-auto px-6 max-w-4xl">
            <SEO
                title="Privacy Policy"
                description="Legal information regarding data collection and privacy at OmniView Labs."
                canonical="/privacy"
            />
            <h1 className="text-4xl font-black text-[#021226] mb-8">Privacy Policy</h1>
            <div className="prose prose-lg text-slate-600">
                <p className="mb-4">Last updated: February 03, 2026</p>
                <p className="mb-6">At OmniView Labs, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and share information about you when you visit our website or use our services.</p>

                <h2 className="text-2xl font-bold text-[#021226] mt-8 mb-4">1. Information We Collect</h2>
                <p className="mb-4">We collect information you provide directly to us, such as when you fill out a form, request a demo, or communicate with us.</p>

                <h2 className="text-2xl font-bold text-[#021226] mt-8 mb-4">2. How We Use Your Information</h2>
                <p className="mb-4">We use the information we collect to provide, maintain, and improve our services, to respond to your comments and questions, and to send you related information.</p>

                <h2 className="text-2xl font-bold text-[#021226] mt-8 mb-4">3. Contact Us</h2>
                <p className="mb-4">If you have any questions about this Privacy Policy, please contact us at info@omniviewlabs.com.</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
